export enum NibblesDiscount {
  TWENTY_OFF = "TWENTY_OFF",
  FIFTY_OFF = "FIFTY_OFF",
  ONE_POUND = "ONE_POUND",
}
